import React from "react";
import { Container, Accordion, Card, Button } from "react-bootstrap";

const TermsComp = () => {
  return (
    <>
      <div class="container mt-5">
        <h1 class="text-center">Terms and Conditions of Service</h1>
        <p class="text-center"><small>These terms and conditions ("Terms") govern the use of the base oil storage and distribution services provided by [Your Company Name], hereinafter referred to as "The Company."</small></p>

        <h2>1. Acceptance of Terms</h2>
        <p>By using the services offered by The Company, you acknowledge that you have read, understood, and agree to be bound by these Terms. These Terms are subject to change without notice, and it is your responsibility to review them periodically.</p>

        <h2>2. Service Description</h2>
        <p>The Company specializes in the storage and distribution of base oil products, including but not limited to Napthenic Oils, Petrolatum, Ink Oils & Solvents, Micro Waxes, Polyethylene (PE) Waxes, and Paraffin Waxes.</p>

        <h2>3. Ordering and Delivery</h2>
        <ul>
            <li>Orders can be placed via our designated ordering channels.</li>
            <li>Delivery times and terms are specified in individual contracts.</li>
            <li>The Company is not liable for any delays or damages during the transportation process that are beyond our control.</li>
        </ul>

        <h2>4. Quality and Product Specifications</h2>
        <p>The Company ensures the quality and specifications of the products as described. Any deviations will be addressed as per the agreed terms in individual contracts.</p>

        <h2>5. Payment Terms</h2>
        <ul>
            <li>Payment terms and methods will be agreed upon in individual contracts.</li>
            <li>Late payments may incur additional charges or affect the delivery of future orders.</li>
        </ul>

        <h2>6. Cancellation and Returns</h2>
        <ul>
            <li>Cancellation of orders may be subject to fees and conditions outlined in individual contracts.</li>
            <li>Returns and refunds are governed by our Returns Policy.</li>
        </ul>

        <h2>7. Liability</h2>
        <ul>
            <li>The Company is not liable for any direct or indirect damages arising from the use of our products.</li>
            <li>We strongly recommend that customers follow safety guidelines and handle our products with care.</li>
        </ul>

        <h2>8. Confidentiality</h2>
        <p>Any confidential information shared between The Company and the client will be treated with the utmost confidentiality and not disclosed to third parties.</p>

        <h2>9. Governing Law and Jurisdiction</h2>
        <ul>
            <li>These Terms are governed by and construed in accordance with the laws of [Your Jurisdiction].</li>
            <li>Any disputes will be subject to the exclusive jurisdiction of the courts of [Your Jurisdiction].</li>
        </ul>

        <h2>10. Termination</h2>
        <p>The Company reserves the right to terminate services if clients violate these Terms or contractual agreements.</p>

        <h2>11. Contact Information</h2>
        <p>If you have any questions or concerns regarding these Terms or our services, please contact us at:</p>
        <p>[Your Company Contact Information]</p>

        <p class="text-center mt-5">
            By using the services provided by The Company, you agree to abide by these Terms and acknowledge that you have read and understood them. If you do not agree with any part of these Terms, please refrain from using our services.
        </p>
    </div>

    </>
  );
};

export default TermsComp;